<!-- <div [class.blurred]="isSearchOpen" class="app-content">
    <router-outlet></router-outlet>
  </div>
  
  <app-search-global-modal *ngIf="isSearchOpen"></app-search-global-modal> -->
<router-outlet></router-outlet>
